import { formatDuration } from '../core/format';

export function renderAudioRoutingTest(container: HTMLElement): () => void {
  container.innerHTML = `
    <h2 style="margin-top:0">Audio Routing Test</h2>
    <p class="text-dim">Use this before practicing through a split cable or show rig.</p>
    <div class="routing-reminder">
      <div class="routing-side routing-left">LEFT<br />BACKING TRACK</div>
      <div class="routing-side routing-right">RIGHT<br />CLICK / CUES</div>
    </div>
    <p class="text-dim">
      Plays a bundled stereo test WAV file. First half plays a 440&nbsp;Hz tone on the LEFT
      channel only. Second half plays an 880&nbsp;Hz tone on the RIGHT channel only.
    </p>
    <div class="row">
      <button class="btn btn-primary" id="play-test-btn">Play Stereo Test (LEFT then RIGHT)</button>
      <button class="btn btn-danger" id="stop-test-btn">Stop Test</button>
    </div>
    <p id="test-status" class="text-dim" style="margin-bottom:0"></p>
  `;

  const playTestBtn = container.querySelector<HTMLButtonElement>('#play-test-btn')!;
  const stopTestBtn = container.querySelector<HTMLButtonElement>('#stop-test-btn')!;
  const testStatus = container.querySelector<HTMLParagraphElement>('#test-status')!;

  let testAudio: HTMLAudioElement | null = null;

  playTestBtn.addEventListener('click', () => {
    testAudio?.pause();
    testAudio = new Audio(`${import.meta.env.BASE_URL}test-audio/stereo-test.wav`);
    testAudio.addEventListener('timeupdate', () => {
      if (!testAudio) return;
      const phase = testAudio.currentTime < testAudio.duration / 2 ? 'LEFT (backing track / PA)' : 'RIGHT (click / in-ear)';
      testStatus.textContent = `Playing - you should currently hear: ${phase} at ${formatDuration(testAudio.currentTime)}`;
    });
    testAudio.addEventListener('ended', () => {
      testStatus.textContent = 'Test complete.';
    });
    testAudio.addEventListener('error', () => {
      testStatus.textContent = 'Could not play the bundled test file.';
    });
    void testAudio.play();
  });

  stopTestBtn.addEventListener('click', () => {
    if (testAudio) {
      const audio = testAudio;
      testAudio = null;
      audio.pause();
      audio.currentTime = 0;
    }
    testStatus.textContent = 'Test stopped.';
  });

  return () => {
    testAudio?.pause();
    testAudio = null;
  };
}
